module.exports = __webpack_public_path__ + "img/dairy-mgmt.75233e2a.png";